import React, { PureComponent } from 'react';

import classNames from 'classnames';
import { Button, withCollapsible } from 'components/ClubComponents';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

const MAX_COMMENT_LENGTH = 250;
const DEFAULT_OBJECT = {};
const DEFAULT_STRING = '';

class CommentDetailContent extends PureComponent {
  static propTypes = {
    item: PropTypes.shape({
      commentClass: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string
      }),
      commentDate: PropTypes.string,
      content: PropTypes.string,
      id: PropTypes.string,
      lastAction: PropTypes.string,
      page: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        module: PropTypes.string
      }),
      status: PropTypes.string,
      type: PropTypes.string,
      user: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        email: PropTypes.string
      })
    }),
    toggle: PropTypes.func,
    collapsed: PropTypes.bool
  };

  get item() {
    const { item } = this.props;

    return item || DEFAULT_OBJECT;
  }

  get content() {
    const item = this.item;
    const { content } = item;

    return content || DEFAULT_STRING;
  }

  get isCommentGreaterThanMax() {
    const content = this.content;

    return content.length > MAX_COMMENT_LENGTH;
  }

  getText(truncate) {
    const content = this.content;

    return this.isCommentGreaterThanMax && truncate
      ? `${content.substring(0, MAX_COMMENT_LENGTH)}...`
      : content;
  }

  render() {
    const { collapsed, toggle } = this.props;

    return (
      <div className="_mt-2">
        <div className="_text-black _line-height-lg _text-left _tw-whitespace-pre-line _tw-overflow-x-auto">
          {this.getText(collapsed)}&nbsp;
          {this.isCommentGreaterThanMax && (
            <Button.Primary
              className={classNames('_h-auto _p-0', {
                'show-more': collapsed,
                'show-less': !collapsed
              })}
              outline
              onClick={toggle}
              data-test="btn-comment-toggle"
            >
              <I18n
                label={`general.${collapsed ? 'view_more' : 'view_less'}`}
              />
            </Button.Primary>
          )}
        </div>
      </div>
    );
  }
}

export default withCollapsible(CommentDetailContent);
